import { render, staticRenderFns } from "./InboxMenu.vue?vue&type=template&id=4626e90f&scoped=true"
import script from "./InboxMenu.vue?vue&type=script&lang=js"
export * from "./InboxMenu.vue?vue&type=script&lang=js"
import style0 from "./InboxMenu.vue?vue&type=style&index=0&id=4626e90f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626e90f",
  null
  
)

export default component.exports